import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = { class: "text-2xl font-bold text-gray-900 mb-6" }
const _hoisted_4 = { class: "text-xs text-gray-400 mb-6" }
const _hoisted_5 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6 space-y-6" }
const _hoisted_6 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_7 = { class: "text-sm text-gray-600" }
const _hoisted_8 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_9 = { class: "text-sm text-gray-600 mb-2" }
const _hoisted_10 = { class: "text-sm text-gray-600 list-disc list-inside space-y-1" }
const _hoisted_11 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_12 = { class: "text-sm text-gray-600 mb-2" }
const _hoisted_13 = { class: "text-sm text-gray-600 list-disc list-inside space-y-1" }
const _hoisted_14 = { class: "text-sm text-gray-600 mt-2" }
const _hoisted_15 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_16 = { class: "text-sm text-gray-600" }
const _hoisted_17 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_18 = { class: "text-sm text-gray-600 list-disc list-inside space-y-1" }
const _hoisted_19 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_20 = { class: "text-sm text-gray-600" }
const _hoisted_21 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_22 = { class: "text-sm text-gray-600" }
const _hoisted_23 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_24 = { class: "text-sm text-gray-600 list-disc list-inside space-y-1" }
const _hoisted_25 = { class: "text-sm text-gray-600 mt-2" }
const _hoisted_26 = {
  href: "/data-deletion",
  class: "text-blue-700 hover:underline"
}
const _hoisted_27 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_28 = { class: "text-sm text-gray-600" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": ""
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString($setup.t('privacy.title')), 1 /* TEXT */),
      _createElementVNode("p", _hoisted_4, _toDisplayString($setup.t('privacy.last_updated')) + ": 04.05.2026", 1 /* TEXT */),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("section", null, [
          _createElementVNode("h2", _hoisted_6, _toDisplayString($setup.t('privacy.intro_title')), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_7, _toDisplayString($setup.t('privacy.intro_text')), 1 /* TEXT */)
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h2", _hoisted_8, _toDisplayString($setup.t('privacy.collect_title')), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_9, _toDisplayString($setup.t('privacy.collect_text')), 1 /* TEXT */),
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", null, _toDisplayString($setup.t('privacy.collect_email')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('privacy.collect_name')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('privacy.collect_photo')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('privacy.collect_profile')), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h2", _hoisted_11, _toDisplayString($setup.t('privacy.facebook_title')), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_12, _toDisplayString($setup.t('privacy.facebook_text')), 1 /* TEXT */),
          _createElementVNode("ul", _hoisted_13, [
            _createElementVNode("li", null, _toDisplayString($setup.t('privacy.facebook_email')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('privacy.facebook_name')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('privacy.facebook_photo')), 1 /* TEXT */)
          ]),
          _createElementVNode("p", _hoisted_14, _toDisplayString($setup.t('privacy.facebook_purpose')), 1 /* TEXT */)
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h2", _hoisted_15, _toDisplayString($setup.t('privacy.google_title')), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_16, _toDisplayString($setup.t('privacy.google_text')), 1 /* TEXT */)
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h2", _hoisted_17, _toDisplayString($setup.t('privacy.purpose_title')), 1 /* TEXT */),
          _createElementVNode("ul", _hoisted_18, [
            _createElementVNode("li", null, _toDisplayString($setup.t('privacy.purpose_auth')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('privacy.purpose_profile')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('privacy.purpose_communication')), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h2", _hoisted_19, _toDisplayString($setup.t('privacy.storage_title')), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_20, _toDisplayString($setup.t('privacy.storage_text')), 1 /* TEXT */)
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h2", _hoisted_21, _toDisplayString($setup.t('privacy.sharing_title')), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_22, _toDisplayString($setup.t('privacy.sharing_text')), 1 /* TEXT */)
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h2", _hoisted_23, _toDisplayString($setup.t('privacy.rights_title')), 1 /* TEXT */),
          _createElementVNode("ul", _hoisted_24, [
            _createElementVNode("li", null, _toDisplayString($setup.t('privacy.rights_access')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('privacy.rights_edit')), 1 /* TEXT */),
            _createElementVNode("li", null, _toDisplayString($setup.t('privacy.rights_delete')), 1 /* TEXT */)
          ]),
          _createElementVNode("p", _hoisted_25, [
            _createTextVNode(_toDisplayString($setup.t('privacy.rights_delete_link')) + " ", 1 /* TEXT */),
            _createElementVNode("a", _hoisted_26, _toDisplayString($setup.t('privacy.rights_delete_page')), 1 /* TEXT */)
          ])
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("h2", _hoisted_27, _toDisplayString($setup.t('privacy.contact_title')), 1 /* TEXT */),
          _createElementVNode("p", _hoisted_28, _toDisplayString($setup.t('privacy.contact_text')), 1 /* TEXT */),
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-sm text-blue-700 mt-1" }, "admin@alerg.eu", -1 /* CACHED */))
        ])
      ])
    ])
  ]))
}